
export enum AgreementsOptions{
    Intermediation = '7EE6C436-0D17-4856-A17B-E8E1F19327CE',
    TermoAdesaoModelo2Risco = '7EB4E5B3-C51E-45BE-AB5D-ED0FFC14D669',
    TermoAdesaoModelo1Risco = 'FE487300-BFFA-439A-A076-7D56BED66BFC',
    TermoAdesaoGanhaGanha = 'DEE7568B-4E7E-461D-AF13-46ADC50C1416',
    TermoAdesaoTabelaTradicional = '1b452a9b-014f-41f6-9a55-a312f9d99abd',
    TermoAdesaoToroZero = 'd9cade8b-4f32-40f9-a6a3-363caabfb006',
    CompraPacoteCorretagem = '19B1CF27-B396-4873-A5AC-E9DDB6F9EB1D',
    CompraRendaFixaFGC = '41274F17-CBED-4985-AB13-98ADEF748AC8',
    RendaFixa = '4E27D349-0E46-4FF8-960F-429C42FFE2E6',
    TesouroDireto = 'EB277837-813A-465D-B211-99B5DC765FCC',
    TermoAdesaoRlp = '2D35AC2F-B7DC-4B2D-902E-FF5AD5F5B381',
    TermoPlataformasNegociacao = "776fbce5-6d6a-4fa7-b7bf-28c4994af0c5",
    TermoPrivacidade = "c86202db-bb24-4980-8817-05eedccdb69a"
}


export enum AgreementsApiVersion{
    VERSION_1 = "v1.0",
    VERSION_1_1 = "v1.1",
}
